import {
  buildFacebookPdpAttributes,
  commonFacebookEventsUtil,
} from '@/shared/features/analytics/utils/facebookCommonAttributes';
import type { ProductDetail } from '../../domain/models/ProductDetail';
import type { PdpEffectiveProductVm } from '../viewModels/pdp.vm';

export function facebookCustomizeProduct(
  product: ProductDetail,
  vm: PdpEffectiveProductVm,
  selectedSizeDisplay?: string,
): void {
  const base = buildFacebookPdpAttributes(product, vm, selectedSizeDisplay);
  commonFacebookEventsUtil('CustomizeProduct', {
    ...base,
    value: '',
    selected_variant: String(vm.activeCustomizationId),
    metal_colour: vm.metal ?? '',
    size: selectedSizeDisplay ?? product.size ?? '',
  });
}
